// src/pages/AuthCallback.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import styled from 'styled-components';
import { getAccessToken, fetchUserProfile } from '@/api/auth';
import { useAuthStore } from '@/store/useAuthStore';

const AuthCallback = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore((state) => state.setUser);
  const setIsLoggedIn = useAuthStore((state) => state.setIsLoggedIn);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    const login = async () => {
      try {
        if (!code) return;

        const { accessToken, refreshToken } = await getAccessToken(code);
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);

        const user = await fetchUserProfile();
        setUser(user);
        setIsLoggedIn(true);

        // ✅ 리다이렉트 처리
        const redirectPath = localStorage.getItem('postLoginRedirect') || '/';
        localStorage.removeItem('postLoginRedirect');
        navigate(redirectPath, { replace: true });
      } catch (err) {
        console.error('❌ 로그인 실패:', err);
        alert('로그인에 실패했습니다.');
      }
    };

    login();
  }, [navigate, setUser, setIsLoggedIn]);

  return (
    <SpinnerContainer>
      <Spin size="large" />
    </SpinnerContainer>
  );
};

export default AuthCallback;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
